import { render, staticRenderFns } from "./AddSchoolData.vue?vue&type=template&id=53b823eb&scoped=true&"
import script from "./AddSchoolData.vue?vue&type=script&lang=js&"
export * from "./AddSchoolData.vue?vue&type=script&lang=js&"
import style0 from "./AddSchoolData.vue?vue&type=style&index=0&id=53b823eb&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b823eb",
  null
  
)

export default component.exports